import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';

export const AlamatDomisili = ({ errors, touched, values, state, props, onValueChange, setFieldValue, handleChange, handleBlur }) => (

    <React.Fragment>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label>Alamat<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="ResidentialAddressLine1" bsSize="sm" invalid={errors.ResidentialAddressLine1 && touched.ResidentialAddressLine1} maxLength={40}
                    />
                    {errors.ResidentialAddressLine1 && touched.ResidentialAddressLine1 ? (
                        <FormFeedback>{errors.ResidentialAddressLine1}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="2" xs="6">
                <FormGroup>
                    <Label>RT<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="ResidentialAddressRT" type="number" bsSize="sm" maxLength="3" invalid={errors.ResidentialAddressRT && touched.ResidentialAddressRT} />
                    {errors.ResidentialAddressRT && touched.ResidentialAddressRT ? (
                        <FormFeedback>{errors.ResidentialAddressRT}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="2" xs="6">
                <FormGroup>
                    <Label>RW<span className="text-danger">*</span></Label>
                    <Input tag={Field} name="ResidentialAddressRW" type="number" bsSize="sm" maxLength="3" invalid={errors.ResidentialAddressRW && touched.ResidentialAddressRW} />
                    {errors.ResidentialAddressRW && touched.ResidentialAddressRW ? (
                        <FormFeedback>{errors.ResidentialAddressRW}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Provinsi<span className="text-danger">*</span> </Label>
                    <Field component="select" name="ResidentialAddressprovinceId"
                        className={errors.ResidentialAddressprovinceId && touched.ResidentialAddressprovinceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.provinces.map((province, i) =>
                            <option key={i} value={province.Id}>{province.Name}</option>
                        )}
                    </Field>
                    {errors.ResidentialAddressprovinceId && touched.ResidentialAddressprovinceId ? (
                        <FormFeedback>{errors.ResidentialAddressprovinceId}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kota<span className="text-danger">*</span></Label>
                    <Field component="select" name="ResidentialAddressCityId"
                        className={errors.ResidentialAddressCityId && touched.ResidentialAddressCityId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)}
                    >
                        <option value="">-- Pilih --</option>
                        {props.residentialCities ? props.residentialCities.map((city, i) =>
                            <option key={i} value={city.Id}>{city.Name}</option>
                        ) : null}
                    </Field>
                    {errors.ResidentialAddressCityId && touched.ResidentialAddressCityId ? (
                        <FormFeedback>{errors.ResidentialAddressCityId}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kecamatan<span className="text-danger">*</span></Label>
                    <Field component="select" name="ResidentialAddressSubDistrict"
                        className={errors.ResidentialSubDistrict && touched.ResidentialSubDistrict ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)} >
                        <option value="">-- Pilih --</option>
                        {props.residentialDistricts ? props.residentialDistricts.map((item, i) =>
                            <option key={i} value={item.Name}>{item.Name}</option>
                        ) : null}
                    </Field>
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kelurahan<span className="text-danger">*</span></Label>
                    <Field component="select" name="ResidentialAddressVillage"
                        className={errors.ResidentialAddressVillage && touched.ResidentialAddressVillage ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        onChange={(e) => onValueChange(e, setFieldValue)} >
                        <option value="">-- Pilih --</option>
                        {props.residentialSubDistricts ? props.residentialSubDistricts.map((item, i) =>
                            <option key={i} value={item.Name}>{item.Name}</option>
                        ) : null}
                    </Field>
                </FormGroup>
            </Col>
            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Negara<span className="text-danger">*</span></Label>
                    <Field component="select" name="ResidentialAddressCountry" disabled
                        className={errors.ResidentialAddressCountry && touched.ResidentialAddressCountry ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                    >
                        <option value="">-- Pilih --</option>
                        <option value="ID">Indonesia</option>
                    </Field>
                    {errors.ResidentialAddressCountry && touched.ResidentialAddressCountry ? (
                        <FormFeedback>{errors.ResidentialAddressCountry}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>

            <Col md="4" xs="6">
                <FormGroup>
                    <Label>Kode Pos<span className="text-danger">*</span></Label>
                    <Input tag={Field} type="tel" maxLength={5} name="ResidentialAddressPostalCode" bsSize="sm" readOnly
                        invalid={errors.ResidentialAddressPostalCode && touched.ResidentialAddressPostalCode}
                    />
                    {errors.ResidentialAddressPostalCode && touched.ResidentialAddressPostalCode ? (
                        <FormFeedback>{errors.ResidentialAddressPostalCode}</FormFeedback>
                    ) : null}
                </FormGroup>
            </Col>
        </Row>
    </React.Fragment>
);


// WEBPACK FOOTER //
// ./src/components/AlamatDomisili.js